import { markRaw } from 'vue'
import type { RegisteredComponent } from '@builder.io/sdk-vue'
import BaseHeader from '~/components/BaseHeader.vue'

export default <RegisteredComponent>{
  name: 'Base Header',
  tag: 'base-header',
  type: 'vue',
  component: markRaw(BaseHeader),
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'Section',
      },
    },
  ],
}
